import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            内容分类导航
          </h2>
          <p className="mt-3 text-foreground-500 max-w-xl mx-auto">
            五大分类频道，精准定位你感兴趣的每一份精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-2xl bg-background-50 hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-background-50 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 group-hover:text-background-200 transition-colors mt-1.5 line-clamp-2">
                {cat.description}
              </p>
              <span className="inline-block mt-3 text-xs text-primary-600 group-hover:text-background-100 transition-colors">
                {cat.count} 篇内容 &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}